import styled from "styled-components";

export const Languages = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  color: ${({ theme }) => theme.palette.grey900};
`;
